// SINGLE SOURCE OF TRUTH for brand colors.
// Change a value here and it propagates to: Tailwind (tailwind.config.js),
// Leaflet map colors, chart colors, manifest.json theme colors, and index.html
// (the last two via `yarn sync-brand-colors`, which also runs automatically
// before `yarn start`/`yarn build`).
module.exports = {
  PRIMARY: "#1A3626",
  PRIMARY_HOVER: "#2D5940",
  PRIMARY_DARK: "#0F2318",
  ACCENT: "#FBA022",
  ACCENT_HOVER: "#D88A1D",
};
